import Web3 from "web3";
import { getRewardPoolAmount, allocateRewardPool } from "@/contract";
import { get_pool_user_num, get_level_address } from "@/api";
import {
  parsePoolUserNums,
  parseLevelAddressList,
  poolIdToLevel,
} from "@/helpers/prizePoolApi.js";
import { PRIZE_POOL_LEVELS } from "../constants.js";
import { formatScaledAmountDisplay } from "@/utils/utils.js";

function tupleFive(res) {
  if (res == null) {
    return ["0", "0", "0", "0", "0"];
  }
  if (Array.isArray(res)) {
    return res.slice(0, 5).map((x) => x);
  }
  return [0, 1, 2, 3, 4].map((i) => res[i] ?? res[String(i)] ?? "0");
}

function bnToDisplayInt(v) {
  try {
    return Web3.utils.toBN(String(v)).toString(10);
  } catch (_) {
    return String(v ?? "0");
  }
}

/** BL 奖金池金额：链上最小单位按 18 位换算，保留三位小数（四舍五入） */
function amountToBlDisplay(raw) {
  const s = bnToDisplayInt(raw);
  try {
    const bn = Web3.utils.toBN(s);
    const sign = bn.isNeg() ? -1 : 1;
    const absStr = bn.abs().toString(10);
    return formatScaledAmountDisplay(sign, BigInt(absStr), 18, 3);
  } catch (_) {
    return s;
  }
}

/**
 * 读取 V1～V5 奖金池人数（后端 API）与池内金额（链上 view）
 * @returns {Promise<Array<{ id: string, label: string, people: string, amount: string }>>}
 */
export async function fetchLevelPrizePoolsFromChain() {
  const [poolUserRes, amounts] = await Promise.all([
    get_pool_user_num(),
    getRewardPoolAmount(),
  ]);

  const nums = parsePoolUserNums(poolUserRes?.data);
  const amts = tupleFive(amounts);

  const rows = PRIZE_POOL_LEVELS.map((level, i) => ({
    id: level.id,
    label: level.label,
    people: bnToDisplayInt(nums[i]),
    amount: amountToBlDisplay(amts[i]),
  }));

  console.log("[display/raw] 全网奖金池 — API 人数与链上金额", {
    get_pool_user_num_raw: poolUserRes?.data,
    getRewardPoolAmount_raw: amounts,
    levels: PRIZE_POOL_LEVELS.map((level, i) => ({
      label: level.label,
      peopleRaw: bnToDisplayInt(nums[i]),
      amountRawMinUnits_bl18: bnToDisplayInt(amts[i]),
      amountDisplay: rows[i].amount,
    })),
  });

  return rows;
}

/** @param {"v1"|"v2"|"v3"|"v4"|"v5"} poolId */
export async function allocateLevelPrizePool(poolId) {
  const level = poolIdToLevel(poolId);
  if (!level) {
    return Promise.reject(new Error("无效的奖金池级别"));
  }
  const listRes = await get_level_address({ level: String(level) });
  const addresses = parseLevelAddressList(listRes?.data);
  return allocateRewardPool(level, addresses);
}
